import { getCartMachine } from '../core/cart';
import { init as initImageLazyloading } from './lazysizes';
import { init as initOffcanvasDrawers } from './offcanvas-drawers';
import { init as initOffcanvasMenu } from './offcanvas-menu';
import { init as initMainHeaderMenuCollapsing } from './header/collapse-nav';
import { init as initCollectionSortFilterControls } from './collection-sort-filter-controls';
import { init as initFabric } from './fabric';
import { init as initKlaviyo } from './klaviyo';
import { init as initFaq } from './faq';
import { init as initAbout } from './about';
import { init as initSearch } from './search';
import { init as initQuickView } from './quick-view';
import { init as initHeader } from './header/header';
import { init as initHeaderDropdownsA11y } from './header/dropdowns-a11y';
import { init as initInstagram } from './instagram';
import { init as initSizeGuide } from './size-guide';
import { init as initFormatInput } from './format-input';
import { init as initDrawerUpsell } from './cartdrawer-upsell';
import { init as initGorgiasChat } from './gorgias-chat';
import { init as initEmbroideryModal } from '../product-embroidering/mount';
import { init as initWishlist } from '../wishlist/pages';
import { init as initSharedWishlist } from '../wishlist/pages/shared-wishlist';
const logErrors = function(err) {
    console.error(err);
};
const cart = getCartMachine();
initHeader().catch(logErrors);
initHeaderDropdownsA11y().catch(logErrors);
initImageLazyloading().catch(logErrors);
initOffcanvasDrawers(cart).catch(logErrors);
initOffcanvasMenu().catch(logErrors);
initMainHeaderMenuCollapsing().catch(logErrors);
initCollectionSortFilterControls().catch(logErrors);
initFabric().catch(logErrors);
initKlaviyo().catch(logErrors);
initInstagram().catch(logErrors);
initFaq().catch(logErrors);
initAbout().catch(logErrors);
initSearch().catch(logErrors);
initSizeGuide().catch(logErrors);
initQuickView().catch(logErrors);
initFormatInput().catch(logErrors);
initDrawerUpsell().catch(logErrors);
initGorgiasChat().catch(logErrors);
initEmbroideryModal().catch(logErrors);
initWishlist().catch(logErrors);
initSharedWishlist().catch(logErrors);
